import {
  GetLoanAutoPaySettingsDocument,
  GetLoanCreditUtilizationDocument,
  GetLoanDocument,
  GetStatementStudioAuthoringContextDocument,
  GetLoanAchRequestsDocument,
  GetLoanStatementsDocument,
  GetLoanTransactionsDocument,
  GetLoanVelocityControlsDocument,
  LedgerBalancesDocument,
} from '../../__generated__/graphql/api';

export const getLoanRefetchQuery = (loanId: string) => ({
  refetchQueries: [
    { query: GetLoanDocument, variables: { id: loanId } },
    { query: GetStatementStudioAuthoringContextDocument, variables: { loanId } },
    { query: GetLoanStatementsDocument, variables: { loanId } },
    { query: GetLoanTransactionsDocument, variables: { loanId } },
    { query: GetLoanVelocityControlsDocument, variables: { loanId } },
    { query: GetLoanAchRequestsDocument, variables: { loanId } },
    { query: GetLoanCreditUtilizationDocument, variables: { loanId } },
    { query: GetLoanAutoPaySettingsDocument, variables: { loanId } },
    { query: LedgerBalancesDocument, variables: { loanId } },
  ],
});
